module.exports = __webpack_public_path__ + "img/50n@2x.2d407627.svg";